import { isNative, nativePlatform } from '@/native/capacitorShell';
import client from '@/services/client';

let wired = false;

// Registers this device for native push and posts the FCM token to the backend.
// No-op on web; safe to call on every auth change.
export async function registerNativePush(navigate) {
  if (!isNative) return;

  const { PushNotifications } = await import('@capacitor/push-notifications');

  if (!wired) {
    wired = true;

    await PushNotifications.addListener('registration', async ({ value }) => {
      try {
        await client.post('/push/tokens', { token: value, platform: nativePlatform });
      } catch (_) { /* retried on next launch */ }
    });

    await PushNotifications.addListener('registrationError', () => { wired = false; });

    await PushNotifications.addListener('pushNotificationActionPerformed', (event) => {
      const link = event?.notification?.data?.link;
      if (link && typeof link === 'string' && link.startsWith('/')) navigate(link);
    });
  }

  let { receive } = await PushNotifications.checkPermissions();
  if (receive !== 'granted') {
    ({ receive } = await PushNotifications.requestPermissions());
  }
  if (receive !== 'granted') return;

  await PushNotifications.register();
}

export async function unregisterNativePush() {
  if (!isNative) return;
  const { PushNotifications } = await import('@capacitor/push-notifications');
  await PushNotifications.unregister().catch(() => {});
}
